import { PromoBanner } from "../components/PromoBanner";
import { ProductsIntro } from "../components/ProductsIntro";
import { Products } from "../components/Products";
import { Features } from "../components/Features";
import { Testimonials } from "../components/Testimonials";
import { useSeo } from "../lib/seo";
import { products as staticProducts } from "../data/products";
import { useProducts } from "../context/ProductsContext";

const SITE_URL = "https://detereco-green.ro";

export default function Home() {
  const { products } = useProducts();
  const list = products.length > 0 ? products : staticProducts;
  useSeo({
    title:
      "Detecogreen | Detergenți premium fabricați în România · Comandă pe WhatsApp",
    description:
      "Detecogreen — detergenți și balsamuri premium fabricați în România. Pachete XXL economice, până la 300 de spălări, transport gratuit. Comandă rapid pe WhatsApp.",
    canonical: `${SITE_URL}/`,
    ogImage: list[0]?.image,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: list.map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Product",
          name: p.title,
          image: p.image,
          description: p.short,
          url: `${SITE_URL}/produs/${p.slug}`,
          brand: { "@type": "Brand", name: "Detecogreen" },
          offers: {
            "@type": "Offer",
            price: p.price,
            priceCurrency: "RON",
            availability: "https://schema.org/InStock",
            url: `${SITE_URL}/produs/${p.slug}`,
          },
        },
      })),
    },
  });

  return (
    <main data-testid="home-page">
      <PromoBanner />
      <ProductsIntro />
      <Products />
      <Features />
      <Testimonials />
    </main>
  );
}
